export function signInNext(ssoToken: string) {
  return fetch(`/api/sign-in?${new Date().getTime()}`, {
    headers: { authorization: `bearer ${ssoToken}` },
  });
}

export function signOutNext() {
  return fetch(`/api/sign-out?${new Date().getTime()}`);
}
